import styleParams from '../WeeklyTimetable/stylesParams';

export default styleParams;
